<template>
  <div class="standardPage">
    <l-map style="height: 100%" :zoom="zoom" :center="centerMap" @ready="mapOnReady">
      <l-tile-layer
        v-if="selectedTileLayer"
        :key="selectedTileLayer.name"
        v-bind="selectedTileLayer.options"
      />

      <div class="t-map-tile-layers-selection">
        <div
          v-for="(tileLayer, index) in tileLayers"
          :key="index"
          class="t-map-tile-layer-item"
          :class="tileLayer.name === selectedTileLayer.name && 'selected'"
          @click="selectTileLayer(tileLayer)"
        >
          <img v-if="tileLayer.img" :src="tileLayer.img" class="t-map-tile-layer-image" />
          {{ $t(`geolocation.mapLayers.${tileLayer.name}`, tileLayer.name) }}
        </div>
      </div>
      <l-geo-json v-if="geojsonTrack != null" :geojson="geojsonTrack" />
      <MarkerTooltip
        v-for="(item, index) in allLessonsInTheme"
        :key="index"
        :theme_id="item.themeId"
        :step_id="item.stepId"
        :lesson_id="item.id"
        :coords="[item.coordinates.lat, item.coordinates.lon]"
        :image="item.tileImage"
        :title="item.title"
        :description="item.stepTitle"
      />
      <icon-user-position
        :haveGeoloc="haveGeoloc"
        :userPosition="userPosition"
        color1="white"
        color2="#e6004c"
      />
      />
      <div class="t-map-button-selection">
        <div class="t-map-button-item" @click="centerMapOnUser()">
          <iconUserCenter class="t-map-button" />
        </div>
        <div class="t-map-button-item" @click="centerMapOnGeoPoint()">
          <iconGeoloc class="t-map-button" />
        </div>
      </div>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet'
import { autoZoomMap } from '@/helpers/geoloc'
import MarkerTooltip from './MarkerTooltip.vue'
import iconUserCenter from '@/components/Geoloc/iconUserCenter.vue'
import iconGeoloc from '@/components/Geoloc/iconGeoloc.vue'
import 'leaflet/dist/leaflet.css'
import IconUserPosition from './iconUserPosition.vue'

export default {
  name: 'GeolocLeaflet',

  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    MarkerTooltip,
    iconUserCenter,
    iconGeoloc,
    IconUserPosition
  },
  data() {
    return {
      streetMapTileLayer: {
        name: 'streetMap',
        img: 'https://maps.gstatic.com/tactile/layerswitcher/ic_default-1x.png',
        options: {
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      },
      googleSateliteTileLayer: {
        name: 'satelite',
        default: true,
        img: 'https://maps.gstatic.com/tactile/layerswitcher/ic_satellite-1x.png',
        options: {
          url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        }
      },
      zoom: 15,
      centerMap: [0, 0],
      watchId: null,
      userPosition: [0, 0],
      tileLayers: [],
      selectedTileLayer: null,
      geojsonTrack: null,
      allLessonsInTheme: [],
      leafletMap: null,
      pointIndex: 0,
      coordsTheme: null,
      haveGeoloc: false
    }
  },
  methods: {
    setPosition(pos) {
      const coords = pos.coords
      if (coords) {
        this.userPosition = [coords.latitude, coords.longitude]
        this.haveGeoloc = true
      }
    },
    gettingErrorPosition(err) {
      console.log(err)
      navigator.geolocation.clearWatch(this.watchId)
      this.haveGeoloc = false
      this.watchId = null
    },
    watchPositionUser() {
      if (!this.watchId)
        this.watchId = navigator.geolocation.watchPosition(
          this.setPosition,
          this.gettingErrorPosition,
          {
            timeout: 30000,
            maximumAge: 0,
            enableHighAccuracy: true
          }
        )
    },
    centerMapOnUser() {
      this.watchPositionUser()
      if (this.haveGeoloc) {
        this.centerMap = this.userPosition
        this.pointIndex = this.allLessonsInTheme.length
      }
    },
    centerMapOnGeoPoint() {
      if (this.allLessonsInTheme.length) {
        const atEndOfVisit = this.pointIndex === this.allLessonsInTheme.length
        if (atEndOfVisit) {
          // if was at the end of visit then autoZoom on bounds of it
          this.autoZoomMapOnGeoPoint()
        } else {
          const lesson = this.allLessonsInTheme[this.pointIndex + 1] || this.allLessonsInTheme[0]
          if (lesson) {
            this.centerMap = [lesson.coordinates.lat, lesson.coordinates.lon]
          }
        }
      } else {
        this.centerMap = this.coordsTheme
      }
    },
    autoZoomMapOnGeoPoint() {
      if (this.leafletMap) {
        if (this.allLessonsInTheme && this.allLessonsInTheme.length) {
          autoZoomMap(
            this.leafletMap,
            this.allLessonsInTheme.map(p => [p.coordinates.lat, p.coordinates.lon])
          )
        } else if (this.centerMap) {
          autoZoomMap(this.leafletMap, [...this.centerMap], { zoom: this.zoom })
        }
      }
    },
    selectTileLayer(tileLayer) {
      this.selectedTileLayer = tileLayer
    },
    mapOnReady(map) {
      this.leafletMap = map
    },
    haveData(value) {
      if (value != null && value !== '') {
        return true
      }
      return false
    }
  },
  async beforeMount() {
    const currentTheme = await this.$store.state.theme.themes.find(
      element => element.id == this.$router.history.current.params.themeId
    )

    if (
      !this.haveData(currentTheme.coordinatesWineEstate) &&
      !this.haveData(currentTheme.geojsonTrack)
    ) {
      this.$router.back()
    }
  },
  async mounted() {
    this.currentTheme = await this.$store.state.theme.themes.find(
      element => element.id == this.$router.history.current.params.themeId
    )

    if (this.haveData(this.currentTheme.coordinatesWineEstate)) {
      this.coordsTheme = [
        this.currentTheme.coordinatesWineEstate.lat,
        this.currentTheme.coordinatesWineEstate.lon
      ]
      this.centerMap = this.coordsTheme
    }
    if (this.haveData(this.currentTheme.geojsonTrack)) {
      this.geojsonTrack = this.currentTheme.geojsonTrack
    }
    this.tileLayers = [this.googleSateliteTileLayer, this.streetMapTileLayer]
    this.selectedTileLayer = this.tileLayers.find(t => t.default)
    this.currentTheme.lessonSteps.forEach(currentStep => {
      currentStep.lessons.forEach(currentLesson => {
        if (
          currentLesson.coordinates.lat != null ||
          currentLesson.coordinates.lon != null ||
          currentLesson.coordinates != '' ||
          currentLesson.coordinates != ''
        ) {
          currentLesson.themeId = this.currentTheme.id
          currentLesson.stepId = currentStep.id
          currentLesson.stepTitle = currentStep.title
          this.allLessonsInTheme.push(currentLesson)
        }
      })
    })
    this.autoZoomMapOnGeoPoint()

    this.watchPositionUser()
  },
  destroy() {
    navigator.geolocation.clearWatch(this.watchId)
    this.watchId = null
  }
}
</script>

<style lang="scss" scoped>
.t-map-button {
  width: 48px;
  height: auto;
  fill: #5357c1;
  cursor: pointer;
}
.t-map-button-item {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 5px;
  margin: 5px;
  font-size: 0.7rem;
  text-align: center;
  cursor: pointer;
}

.standardPage {
  position: fixed; //for navbar
  width: 100%;
  height: 100vh;
  background-attachment: fixed;
}

@media only screen and (min-width: 1024px) {
  .container {
    display: flex;
    flex-direction: column;
    border-radius: 60px 60px 0px 0px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    float: left;
    margin-top: -60px;
  }
  .block {
    display: flex;
    flex-direction: column;
    padding: 25px 5px 0 25px;
    padding-top: 75px;
  }

  .t-map-tile-layers-selection {
    position: absolute;
    z-index: 9999;
    bottom: 10px;
    left: 10px;
  }
  .t-map-tile-layer-item {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 5px;
    margin: 10px;
    font-size: 0.7rem;
    text-align: center;
    cursor: pointer;
    &.selected {
      display: none;
    }
  }
  .t-map-tile-layer-image {
    width: 48px;
    height: auto;
  }

  .t-map-button-selection {
    position: fixed;
    z-index: 9999;
    top: 100px;
    right: 10px;
    display: flex;
    align-items: row;
  }
}

@media only screen and (max-width: 1024px) {
  .t-map-tile-layers-selection {
    position: fixed;
    z-index: 9999;
    top: calc(100% - 150px);
    left: 10px;
  }
  .t-map-tile-layer-item {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 5px;
    padding: 2px;
    margin: 10px 0;
    font-size: 0.7rem;
    text-align: center;
    cursor: pointer;
    &.selected {
      display: none;
    }
  }

  .t-map-tile-layer-image {
    width: 48px;
    height: auto;
  }
  .t-map-button-selection {
    position: fixed;
    z-index: 9999;
    top: 75px;
    right: 10px;
    display: flex;
    align-items: row;
  }
}
</style>
